import {
    AnimationBaseController,
    Graphic,
    IAnimationControllerConfiguration,
    Inject, ModelEvents,
} from '@denishussar/html5-game-engine';
import { Graphics, Point } from 'pixi.js';
import { SavesManager } from '../../../game/Managers/SavesManager';
import { AnalyticsController } from '../../Services/Analytics/AnalyticsController';
import { AnimationContents } from '../../../AnimationContents';
import { ButtonController, IButtonControllerOptions } from '../../Common/ButtonController';
import { DevConfig } from '../../Common/DevConfig';
import { GreenButtonTextStyle } from '../../Constants/TextStyles';
import { LocalizationContents } from '../../LocalizationContents';
import { GameLogic } from '../../Logic/GameLogic';
import { GameModel, GameStateEnum } from '../../Models/GameModel';
import { ISocialControllerOptions, SocialController } from '../Social/SocialController';
import { UIActionController } from './Main/UIActionController';
import { ITopBarMenuControllerOptions, TopBarMenuController } from './TopBarMenuController';
import {
    GameEvent,
    GameEventPopupButtonName,
    GameEventPopupName,
    GameEventSceneButtonClick
} from '../../Constants/GameEvent';
import {ModalsNames} from "../../Common/MadalsManager/ModalsList";
import {
    IConfirmationsBuyEmbroideryControllerOptions
} from "../Modals/Confirmations/ConfirmationsBuyEmbroideryController";
import {IConfirmationsConfirmControllerOptions} from "../Modals/Confirmations/ConfirmationsConfirmController";
import {ConfirmationsYouRewardType} from "../Modals/Confirmations/ConfirmationsYouRewardController";

export interface IMainScreenControllerOptions {
    opacity: boolean;
}

/**
 * Represents the main screen view
 */
export class MainScreenController extends AnimationBaseController {
    $model: GameModel;
    _width: number;

    _btnPlayStartPos: PIXI.Point;

    public constructor(
        @Inject protected options: IMainScreenControllerOptions,
        @Inject protected gameLogic: GameLogic,
        @Inject private saveManager: SavesManager,
        @Inject private modelEvents: ModelEvents,
        @Inject private model: GameModel,
    ) {
        super('MainScreenScreenController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return <IAnimationControllerConfiguration>{
            animationContent: AnimationContents.MAIN_SCREEN_JSON,
            libraryName: 'main_screen',
            childControllers: {
                btn_decor: { // TODO: what for is this?
                    instanceName: 'btn_decor',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                        },
                    },
                },
                btn_book: {
                    instanceName: 'btn_book',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            this.modelEvents.dispatch(this.model, GameEvent.sceneButtonClick, <GameEventSceneButtonClick>{ buttonName: 'Collection', status });

                            if (!status) {
                                return;
                            }

                            this.gameLogic.setState(GameStateEnum.catalog);
                        },
                    },
                },
                btn_play: {
                    instanceName: 'btn_play',
                    controller: ButtonController,
                    options: <IButtonControllerOptions>{
                        onClick: (status: boolean) => {
                            this.onPlayClick();
                        },
                        label: LocalizationContents.getText('Play'),
                    },
                },
                action: { // TODO: what for is this?
                    instanceName: 'action_container',
                    controller: UIActionController,
                    model: this.$model,
                    options: {
                        showBox: !this.gameLogic.isFTUE,
                    },
                },
                topBarMenu: {
                    controller: TopBarMenuController,
                    model: this.$model,
                    options: <ITopBarMenuControllerOptions>{
                        showSettings: true,
                        showLives: false,// true,
                        showCoins: !this.gameLogic.isFTUE,
                        onClickExit: (status: boolean) => {
                        },
                    },
                },
                social: {
                    controller: SocialController,
                    model: this.$model,
                    options: <ISocialControllerOptions>{},
                },
                // friendsList: { // TODO replace call to modal manager
                //     controller: FriendsListModalController,
                //     model: this.$model,
                //     options: <IFriendsListControllerOptions>{
                //         onExit: () => {
                //             this.removeChildControllerByName('friendsList');
                //         }
                //     }
                // }
            },
        };
    }

    protected onInitialize() {
        this._width = this.width;
        this.getDisplayObjectByQuery('btn_decor')[0].visible = false;

        if (DevConfig.HIDE_ACTIONS) {
            const controller = this.$childControllers.get('action');
            controller.visible = false;
        }

        this.setTextStyleByQuery('btn_play.label', GreenButtonTextStyle);
        if (this.options.opacity) {
            this.alpha = 0;
        }

        const btnBookController = this.$childControllers.get('btn_book');
        btnBookController.visible = !this.gameLogic.isFTUE;

        console.warn('create the new main screen');

        if (this.gameLogic.isFTUE === false) {
            this.gameLogic.setState(GameStateEnum.catalog);
        }

        // 2 загрузка главного экрана
        /*
        if (
            !this.saveManager.hasAnatalyticFlag(AnalyticsEventEnum.loadMainScreenSecond) &&
            this.saveManager.hasAnatalyticFlag(AnalyticsEventEnum.loadMainScreenFirst)
        ) {
            this.saveManager.saveAnalyticFlag(AnalyticsEventEnum.loadMainScreenSecond);
            this.analytics.sendEvent(AnalyticsEventEnum.loadMainScreenSecond);
        }

        // 1 загрузка главного экрана
        if (!this.saveManager.hasAnatalyticFlag(AnalyticsEventEnum.loadMainScreenFirst)) {
            this.saveManager.saveAnalyticFlag(AnalyticsEventEnum.loadMainScreenFirst);
            this.analytics.sendEvent(AnalyticsEventEnum.loadMainScreenFirst);
        }
         */

        this._btnPlayStartPos = this.$childControllers.get('btn_play').display.position.clone();

        const intervalID = setInterval(() => {
            if (window['gamePreloaderProgress'] !== -1) {
                window['gamePreloaderProgress'] = -1;
                clearInterval(intervalID);
            }
        }, 2000);
    }

    onDestroy() {
        super.onDestroy();
        console.warn('destroy main screen');
    }

    protected onResize(width: number, height: number, scale: number) {
        const margin = 20;

        const topLeftPoint = this.display.toLocal(new Point(0, 0), this.renderer.stage);
        const topRightPoint = this.display.toLocal(new Point(width, 0), this.renderer.stage);
        const bottomLeftPoint = this.display.toLocal(new Point(0, height), this.renderer.stage);
        const bottomRightPoint = this.display.toLocal(new Point(width, height), this.renderer.stage);
        const bottomCenterPoint = this.display.toLocal(new Point(width / 2, height), this.renderer.stage);

        const btnDecor = this.$childControllers.get('btn_decor').display;
        const btnPlay = this.$childControllers.get('btn_play').display;
        const btnBook = this.$childControllers.get('btn_book').display;

        this.setPosByQuery(
            'btn_decor',
            topLeftPoint.x + btnDecor.width / 2 + margin / 2,
            bottomLeftPoint.y - btnDecor.height / 2 - margin / 2,
        );
        this.setPosByQuery(
            'btn_play',
            this.gameLogic.isFTUE ? bottomCenterPoint.x : this._btnPlayStartPos.x,
            bottomCenterPoint.y - btnPlay.height / 2 - margin / 2,
        );
        this.setPosByQuery(
            'btn_book',
            btnBook.x,
            btnPlay.y,
        );

        const action = this.$childControllers.get('action').display;
        action.x = topLeftPoint.x + margin;
        action.y = topLeftPoint.y + Math.min(200, ((bottomLeftPoint.y - topLeftPoint.y) - action.height) / 2 + margin);

        const social = this.$childControllers.get('social');
        social.x = topLeftPoint.x;
        social.y = topLeftPoint.y;
    }

    protected onUpdate(frameRate: number) {

    }

    protected disablePlayButtonBefore: number;

    protected onPlayClick(): void {
        if (this.disablePlayButtonBefore > Date.now()) return;
        this.disablePlayButtonBefore = Date.now() + 5000;

        this.modelEvents.dispatch(this.model, GameEvent.sceneButtonClick, <GameEventSceneButtonClick>{ buttonName: 'Play' });

        let picture = this.gameLogic.getLastEditedPicture();
        let save = picture ? this.gameLogic.getSave(picture.id) : undefined;

        /*
        if (!this.saveManager.hasAnatalyticFlag(AnalyticsEventEnum.clickButtonPlay)) {
            this.saveManager.saveAnalyticFlag(AnalyticsEventEnum.clickButtonPlay);
            this.analytics.sendEvent(AnalyticsEventEnum.clickButtonPlay);
        }
         */

        if (this.gameLogic.isFTUE) {
            const ftuePicture = this.gameLogic.getFTUEPicture();

            if (ftuePicture) {
                picture = ftuePicture;
                this.gameLogic.setPicture(picture);
                return;
            }
        }

        if (picture && save && this.gameLogic.getPercentageProgress(save) < 100) {
            this.gameLogic.setPicture(picture);
            return;
        }

        picture = this.gameLogic.getFreePicture();
        if (picture) {
            this.gameLogic.setPicture(picture);
            return;
        }

        picture = this.gameLogic.getFirstPictureForSale();
        if (picture) {
            const album = this.$model.albumLibrary.getAlbumByPicture(picture.id);
            this.$model.currentAlbum = album.id;
            this.gameLogic.setState(GameStateEnum.catalog);
        }
    }
}
